import React from 'react';
import { StandardBanner, StandardBannerProps } from '@noths/polaris-client-ribbons-design-system';

import { trackLinkClick } from '../../../tracking/common/banner';
import { trackImpression } from '../../../tracking/common/trackImpression';
import { TrackingContext } from '../../../types/TrackingContext';
import { SectionContainer } from '../../molecules/SectionContainer/SectionContainer';
import * as styles from './StandardBannerSection.style';

export interface StandardBannerSectionProps extends StandardBannerProps {
  trackingTitle: string;
  trackingPosition?: number;
}

export const StandardBannerSection = ({
  trackingPosition,
  trackingTitle,
  ...restOfProps
}: StandardBannerSectionProps) => {
  const trackingContext: TrackingContext = {
    trackingPosition,
    trackingTitle,
    trackingContentType: 'Standard banner',
  };

  return (
    <SectionContainer wrapperStyles={styles.wrapper} maxWidth="full">
      <StandardBanner
        onVisible={() => trackImpression(trackingContext)}
        onLinkClick={(e: React.MouseEvent<HTMLAnchorElement>) =>
          trackLinkClick(e, trackingContext, 'Link')
        }
        {...restOfProps}
      />
    </SectionContainer>
  );
};

export type { StandardBannerProps };
